/** Skip-to-content: the first focusable element on every page, signed in or out (02-patterns §4). */
export function SkipLink() {
  return <a href="#main" className="skip-link">Skip to content</a>;
}
